export const defaultTransition = {
    ease: [0.65, 0, 0.35, 1],
    duration: 0.25,
};

export const easeInOut = {
    ease: "easeInOut",
    duration: 0.4,
};

export const circInOutFast = {
    ease: [0.86, 0, 0.07, 1],
    duration: 0.1
};

